import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Transition } from '../Transition';
import { PaymentMethod } from '../../interfaces/PaymentMethod';

const PaymentCheck = () => {
  
  const search = useLocation().search;
  const paymentFinished = new URLSearchParams(search).get(
    "payment"
  );
  
  useEffect(() => {
    if (paymentFinished) {
      localStorage.setItem('sofortPayment', paymentFinished);
      let paymentMethod =
      sessionStorage.getItem('pepper-payment-method') ?? '';
      if (paymentMethod === PaymentMethod.BIZUM) {
        window.close();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
      <Transition />
    </>
  )
}

export default PaymentCheck
